import { render, staticRenderFns } from "./laporan_nop_tidak_boleh_digunakan.vue?vue&type=template&id=ff66ba0a&"
import script from "./laporan_nop_tidak_boleh_digunakan.vue?vue&type=script&lang=js&"
export * from "./laporan_nop_tidak_boleh_digunakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports